var divider_viewer_rtlignore_default = {
  "divider-container": "Fqrxq",
  "divider-container--double": "aV74g",
  "divider": "pWGo0",
  "divider--single": "bmoLn",
  "divider--double": "i7BFB",
  "divider--dashed": "ReIn-",
  "divider--dotted": "lc-O0",
  "divider--small": "_2jMmx",
  "divider--medium": "GmiJz",
  "divider--large": "_8DRS1",
  "divider--left": "mCjll",
  "divider--center": "PWh2X",
  "divider--right": "FqUBD",
  "svgFixerContainer": "aazhH",
  "emptyChar": "ZZC96"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
